module.exports = __webpack_public_path__ + "static/media/image-2.7d23947b.jpg";